import AttributionModelsIcon from '@precis-digital/kurama/icons/AttributionModelsIcon';
import BudgetOptimiserIcon from '@precis-digital/kurama/icons/BudgetOptimiserIcon';
import ConnectDataSourcesIcon from '@precis-digital/kurama/icons/ConnectDataSourcesIcon';
import CreativeReportingIcon from '@precis-digital/kurama/icons/CreativeReportingIcon';
import EnhancedSignalsIcon from '@precis-digital/kurama/icons/EnhancedSignalsIcon';
import MimirIcon from '@precis-digital/kurama/icons/MimirIcon';
import PresentationBoardIcon from '@precis-digital/kurama/icons/PresentationBoardIcon';
import CreativeAssetsIcon from '@precis-digital/kurama/icons/CreativeAssetsIcon';
import { type ReactElement } from 'react-markdown/lib/react-markdown';
import { APP_ROUTES } from '../routes';
interface AlvieAppMeta {
  id: AlvieAppId;
  icon: ReactElement;
  uri: string;
}
export type AlvieAppId = 'precis-reporting-solutions' | 'bifrost-extract-connectors' | 'attribution-models' | 'budget-optimiser' | 'mimir' | 'enhanced-signals' | 'creative-reporting' | 'creative-assets';
export const ALVIE_APPS_REGISTRY: Record<AlvieAppId, AlvieAppMeta> = {
  'precis-reporting-solutions': {
    id: 'precis-reporting-solutions',
    icon: <PresentationBoardIcon />,
    uri: APP_ROUTES.reportingSolutions.basePage
  },
  'bifrost-extract-connectors': {
    id: 'bifrost-extract-connectors',
    icon: <ConnectDataSourcesIcon />,
    uri: APP_ROUTES.connectors.basePage
  },
  'attribution-models': {
    id: 'attribution-models',
    icon: <AttributionModelsIcon />,
    uri: APP_ROUTES.attributionModels.basePage
  },
  'budget-optimiser': {
    id: 'budget-optimiser',
    icon: <BudgetOptimiserIcon />,
    uri: APP_ROUTES.budgetOptimiser.basePage
  },
  mimir: {
    id: 'mimir',
    icon: <MimirIcon />,
    uri: APP_ROUTES.mimir.basePage
  },
  'enhanced-signals': {
    id: 'enhanced-signals',
    icon: <EnhancedSignalsIcon />,
    uri: APP_ROUTES.enhancedSignals.basePage
  },
  'creative-reporting': {
    id: 'creative-reporting',
    icon: <CreativeReportingIcon />,
    uri: APP_ROUTES.creativeReporting.basePage
  },
  'creative-assets': {
    id: 'creative-assets',
    icon: <CreativeAssetsIcon />,
    uri: APP_ROUTES.creativeAssets.basePage
  }
};